import { http } from '../config/config-receituario'

export default {
    listar: async (token) => {
        return http.get('unidades', {
            headers: {
                'Authorization': token
            }
        })
    },
    salvar: (token, unidade) => {
        return http.post('unidades', unidade, {
            headers: {
                'Authorization': token
            }
        })
    },
    deletar: (token, id) => {
        return http.delete(`unidades/${id}`, {
            headers: {
                'Authorization': token
            }
        })
    },
    update: (token, unidade) => {
        return http.put(`unidades/${unidade.id}`, unidade, {
            headers: {
                'Authorization': token
            }
        })
    }

}